import type { Point } from 'geojson';
import { useMemo } from 'react';

import { GeoLocation } from '@pflegia/types/common/location/location';
import { findMinDistanceIndex } from '@pflegia/util/common/distance';

type Location = Pick<GeoLocation, 'formattedAddress' | 'location'>;

const useCandidateLocationForJob = (candidateLocations?: Location[], jobPositionLocation?: Location) => {
  const candidateClosestLocation = useMemo<Location | null>(() => {
    if (!candidateLocations?.length || !jobPositionLocation) return null;
    const closestIndex = findMinDistanceIndex(
      candidateLocations.map(candidateLocation => candidateLocation.location as Point),
      jobPositionLocation.location as Point,
    );
    return candidateLocations[closestIndex];
  }, [candidateLocations, jobPositionLocation]);

  const candidateLocation = useMemo(
    () =>
      candidateClosestLocation
        ? {
            __typename: 'GeoLocation',
            formattedAddress: candidateClosestLocation.formattedAddress,
            location: {
              type: 'Point',
              coordinates: [
                Number(candidateClosestLocation.location.coordinates?.[0]) || 0,
                Number(candidateClosestLocation.location.coordinates?.[1]) || 0,
              ],
            },
          }
        : undefined,
    [candidateClosestLocation],
  );

  return { candidateLocation };
};

export default useCandidateLocationForJob;
